import React, { FC, useEffect, useState } from "react";
import { Element } from "../../../models/elementModel";
import "react-tippy/dist/tippy.css";
import { Tooltip } from "react-tippy";
import Iframe from "react-iframe";
import produce from "immer";
import { useDispatch, useSelector } from "react-redux";
import { getSession, getViewRemark } from "../../../selectors/appSelectors";
import { SystemTypes } from "../../../utils/constants";
import { startEditSession } from "../../../actions/sessionListAction";
import './Remarks.scss';

export interface RenderVideoEmbedProps {
  index: string;
  element: Element;
  isPreview: boolean;
}

const VideoEmbedElement: FC<RenderVideoEmbedProps> = ({
  index,
  element,
  isPreview,
}) => {
  const dispatch = useDispatch();
  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);

  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark);
  }, [sessionState])

  const selectElementAction = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    const newSession = produce(sessionState, (draft) => {
      draft.selectedElementId = element.id;
      draft.selectedType = SystemTypes.ELEMENT;
    });
    dispatch(startEditSession(newSession));
  };

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };
  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end

  return (
    <div key={index} style={{ ...defaultStyle }}>
      {element.properties.url && (
        <Tooltip title={element.properties.tooltip}>
          <Iframe
            url={element.properties.url}
            width={`${
              element.styles.width === "" ||
              element.styles.width === "0" ||
              element.styles.width === undefined
                ? ""
                : element.styles.width + "px"
            }`}
            height={`${
              element.styles.height === "" ||
              element.styles.height === undefined ||
              element.styles.height === "0"
                ? ""
                : element.styles.height + "px"
            }`}
            id={element.properties.id}
            display="inline"
            position="relative"
            frameBorder={0}
            allow="*"
            styles={{ ...styleObj }}
            className={`${
              element.properties.display === false ? "blur-element" : ""
            }`}
          />
        </Tooltip>
      )}
      {element.type === "video" && !element.properties.url && (
        <img
          src="https://www.online-tech-tips.com/wp-content/uploads/2019/08/cropped-video-not-found.png"
          alt="img_not_found"
          width={`${
            element.styles.width === "" ||
            element.styles.width === undefined ||
            element.styles.width === "0"
              ? ""
              : element.styles.width + "px"
          }`}
          height={`${
            element.styles.height === "" ||
            element.styles.height === undefined ||
            element.styles.height === "0"
              ? ""
              : element.styles.height + "px"
          }`}
          className={`${
            element.properties.display === false ? "blur-element" : ""
          }`}
        />
      )}
      {element.type === "map" && !element.properties.url && (
        <img
          src="http://www.saj.usace.army.mil/portals/44/siteimages/InvasiveSpec/sprayschedules/No%20Map%20Available.jpg"
          alt="img_not_found"
          width={`${
            element.styles.width === "" ||
            element.styles.width === undefined ||
            element.styles.width === "0"
              ? ""
              : element.styles.width + "px"
          }`}
          height={`${
            element.styles.height === "" ||
            element.styles.height === undefined ||
            element.styles.height === "0"
              ? ""
              : element.styles.height + "px"
          }`}
          className={`${
            element.properties.display === false ? "blur-element" : ""
          }`}
        />
      )}
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </div>
  );
};

export default VideoEmbedElement;
